module.exports = __webpack_public_path__ + "media/study-main.99155264.mp4";